import React from 'react';
import { TypedMemo } from '../../../../common/types';
import { Panel, PanelHead } from '../../../components/primitives/Panel';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the settings sections; each part uses its own slice of it */
import styles from './PlatformSettings.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface SettingsCardProps {
  title: string;
  /** The small label on the right of the head ("Direct post"). */
  tag?: string;
  testId: string;
  children: React.ReactNode;
  /** The post buttons, repeated under the consent line. */
  footer?: React.ReactNode;
}

/** The frame of the settings section of one platform in the Composer. */
const SettingsCardComponent: React.FC<SettingsCardProps> = ({ title, tag, testId, children, footer }) => (
  <Panel>
    <PanelHead title={title} right={tag} />
    <div className={styles.body} data-testid={testId}>
      {children}
      {footer === undefined ? null : <div className={styles.foot}>{footer}</div>}
    </div>
  </Panel>
);

export const SettingsCard = TypedMemo(SettingsCardComponent);
